import { api } from "@/builders/axios";
import { GroupData } from "@/builders/types/group";

const get = function (id: number) {
  return api
    .get<{
      data: GroupData;
    }>(`groups/${id}`)
    .then(({ data }) => data);
};

const put = function (variables: {
  id: number;
  data: Partial<{ thumbnail_id: number; name: string; description: string }>;
}) {
  const { id, data } = variables;
  return api.put(`/groups/${id}`, data).then(({ data }) => data);
};

const del = function (id: number) {
  return api.delete(`/groups/${id}`);
};

export const id = {
  get,
  put,
  del,
};
